import { normalizeItemPayload } from "./workAnalyzerUtil";

export function savedImagePreview(items, material) {
  const array = (value, fallback) => {
    if (Array.isArray(value)) return [...value];
    try { return JSON.parse(value); } catch { return fallback; }
  };
  return items.map(item => {
    const kant = Array.isArray(item.kant) ? item.kant
      : String(item.kant || "[-,0,0]").replace(/[\[\]"']/g, "").split(",");
    return { ...item, importMaterial: material,
      size: array(item.size, [0, 0, 18]),
      kant: [Number(kant[1]) ? kant[0] : "-", Number(kant[1]) || 0,
        Number(kant[2]) ? kant[0] : "-", Number(kant[2]) || 0],
      colorId: item.color?.colorId ?? null, millingId: item.milling?.millingId ?? null
    };
  });
}

export async function saveImagePreview({ items, originalIds, objectId, workId, update, create, remove }) {
  const payloads = items.map(item => ({
    ...normalizeItemPayload({ ...item,
      color: item.colorId == null ? null : { colorId: item.colorId },
      milling: item.millingId == null ? null : { millingId: item.millingId },
      millingVariantId: item.millingId === item.milling?.millingId ? item.millingVariantId : "",
      object: { objectId }, work: { workId }
    }),
    color: { colorId: item.colorId ?? null },
    milling: { millingId: item.millingId ?? null }
  }));
  const existing = payloads.filter(item => item.itemId != null);
  const added = payloads.filter(item => item.itemId == null);
  const retained = new Set(existing.map(item => String(item.itemId)));
  const deleted = originalIds.filter(id => !retained.has(String(id)));
  const saved = [];
  if (existing.length) saved.push(...await update(existing));
  if (deleted.length) await remove(deleted);
  if (added.length) saved.push(...await create(added.map(item => ({ ...item,
    color: item.color.colorId == null ? null : item.color,
    milling: item.milling.millingId == null ? null : item.milling
  }))));
  return saved;
}
